import React, { FC, RefObject } from 'react'
import { Direction, REQUEST_CONFIGS_KEYS } from '@services/constants'
import TextInput from '../inputs/text.inputs'
import RadioInput from '../inputs/radio.input'
import {
	classes,
	isCase1SectionA,
	isCase3or5or6SectionA,
	isCase3SectionA,
	isCase4SectionA,
	isCase5SectionA,
	isCase6SectionA,
	isOccupationSectionA,
	isOccupationSectionB,
	isOccupationSectionC,
	isOccupationSectionD,
	isOccupationSectionE
} from './__index.utils'
import { CheckboxList, RadioList, SelectList } from '@utils/request'
import * as utilsList from './__index.utils'
import Notification from '@components/ui/notification'
import CheckboxInput from '../inputs/checkbox.input'
import SelectInput from '../inputs/select.inputs'
import MeasurementInput from '../inputs/measurement.input'
import { joinClasses } from '@utils/styles'
import TextAreaInput from '../inputs/textarea.inputs'
import MaskedTextInput from '../inputs/textWithValidation.inputs'
import DateFilterInput from '../inputs/datefilter.input'

const Step4_2RequestOccupation = ({
	pageAssets,
	pageUtils,
	formInputs,
	errors,
	updateInput,
	onFixError,
	isSummaryStep = false,
	// *******
	updateCheckBoxInput
}) => {
	const {
		whatToDo,

		// ***********************
		mainUseOfExistingBuilding,
		doYouWantToChangeCurrentUse,
		projectedUse,
		// ***********************
		typesOfWorkOccupation,
		projectedUseNewOccupation,
		projectedUseOccupation,
		currentUseOccupation,
		additionalProjectedUseOccupation,
		conditionalProjectedUseOccupation,
		occupantNameSectionA,
		occupiedAreaSectionA,
		occupiedAreaUnitSectionA,
		occupationActivityDescription,
		isLocalOrTerrain,
		occupationActivityType,
		occupationActivityTypeDetails,
		occupantNameSectionB,
		occupiedAreaSectionB,
		occupiedAreaUnitSectionB,
		conditionalUseAuthorizationRequest,
		conditionalUseNumber,
		executiveCommitteeResolutionNumber,
		startDateOccupation,
		endDateOccupation,
		isLocalModificationsRequired,
		isEnseigneInstallationPrevue,
		isAlcoholPermitRequired,
		alcoholPermitActivityType,
		alcoholPermitActivityTypeDetails,
		isMunicipalCertificateRequired,
		isTerraceModificationRequired,
		isLocataireOccupation
	} = formInputs

	const radioListTypesOfWorkRenovation: CheckboxList[] =
		utilsList.radioListTypesOfWorkRenovation(pageAssets)

	const radioListTypesOfWorkOccupation: RadioList[] =
		utilsList.radioListTypesOfWorkOccupationOptions(pageAssets)

	const radioListMeasurementUnit: RadioList[] =
		utilsList.radioListMeasurementUnit(pageAssets)

	const radioListMeasurement2Unit: RadioList[] =
		utilsList.radioListMeasurement2Unit(pageAssets)

	const radioIsLocalOrTerrainOptions: RadioList[] =
		utilsList.radioIsLocalOrTerrainOptions(pageAssets)

	const radioListOccupationActivityTypeCase1: RadioList[] =
		utilsList.radioListOccupationActivityTypeCase1(pageAssets)

	const radioListOccupationActivityTypeCase2: RadioList[] =
		utilsList.radioListOccupationActivityTypeCase2(pageAssets)

	const radioListYesNo: RadioList[] = utilsList.radioListYesNo(pageAssets)

	const getLabelFromList = (list, value) => {
		return list?.find((element) => element.value == value?.toString())?.label
	}

	const selectListProjectedUseNewOccupation: SelectList[] =
		utilsList.selectListProjectedUseNewOccupation(pageAssets)

	const selectListCurrentUseOccupation: SelectList[] =
		utilsList.selectListCurrentUseOccupation(pageAssets)

	const radioListAlcoholPermitActivityType: RadioList[] =
		utilsList.radioListAlcoholPermitActivityType(pageAssets)

	const radioListOwnerOrRenter = utilsList.radioListOwnerOrRenter(pageAssets)

	return (
		<>
			{!isSummaryStep && (
				<h4 className={pageUtils.classes.h4}>
					{pageAssets?.request_form_occupation_informations}
				</h4>
			)}

			<RadioInput
				name={typesOfWorkOccupation.name}
				label={typesOfWorkOccupation.label}
				value={typesOfWorkOccupation.value}
				list={radioListTypesOfWorkOccupation}
				direction={Direction.vertical}
				hasError={errors!.includes(typesOfWorkOccupation.name)}
				onChange={(value) => updateInput(typesOfWorkOccupation.name, value)}
				ref={typesOfWorkOccupation.ref as RefObject<HTMLInputElement>}
				required={typesOfWorkOccupation.required}
				hasBackgroundWrapper={true}
				isSummaryStep={isSummaryStep}
			/>

			{/******************* Section A *******************/}
			{isOccupationSectionA(typesOfWorkOccupation.value) && (
				<>
					<h5 className={pageUtils.classes.h5}>
						{getLabelFromList(
							radioListTypesOfWorkOccupation,
							typesOfWorkOccupation.value
						)?.replace(/\*\*/g, '')}
					</h5>

					{isCase1SectionA(typesOfWorkOccupation.value) && (
						<>
							{/* Question 9 */}
							<SelectInput
								id={projectedUseNewOccupation.name}
								label={projectedUseNewOccupation.label}
								value={projectedUseNewOccupation.value}
								list={selectListProjectedUseNewOccupation}
								hasError={errors!.includes(projectedUseNewOccupation.name)}
								onChange={(value) =>
									updateInput(projectedUseNewOccupation.name, value)
								}
								ref={
									projectedUseNewOccupation.ref as RefObject<HTMLSelectElement>
								}
								required={projectedUseNewOccupation.required}
								isSummaryStep={isSummaryStep}
							/>
						</>
					)}

					{isCase4SectionA(typesOfWorkOccupation.value) && (
						<>
							{/* Question 9.2 */}
							<SelectInput
								id={currentUseOccupation.name}
								label={currentUseOccupation.label}
								value={currentUseOccupation.value}
								list={selectListCurrentUseOccupation}
								hasError={errors!.includes(currentUseOccupation.name)}
								onChange={(value) =>
									updateInput(currentUseOccupation.name, value)
								}
								ref={currentUseOccupation.ref as RefObject<HTMLSelectElement>}
								required={currentUseOccupation.required}
								isSummaryStep={isSummaryStep}
							/>
						</>
					)}

					{isCase3or5or6SectionA(typesOfWorkOccupation.value) && (
						<div
							className={joinClasses([
								pageUtils.classes.fieldsContainer,
								'fieldsContainer'
							])}
						>
							{/* Question 9.2 */}
							<SelectInput
								id={currentUseOccupation.name}
								label={currentUseOccupation.label}
								value={currentUseOccupation.value}
								list={selectListCurrentUseOccupation}
								hasError={errors!.includes(currentUseOccupation.name)}
								onChange={(value) =>
									updateInput(currentUseOccupation.name, value)
								}
								ref={currentUseOccupation.ref as RefObject<HTMLSelectElement>}
								required={currentUseOccupation.required}
								isSummaryStep={isSummaryStep}
							/>

							{isCase3SectionA(typesOfWorkOccupation.value) && (
								<>
									{/* Question 9.1 */}
									<SelectInput
										id={projectedUseOccupation.name}
										label={projectedUseOccupation.label}
										value={projectedUseOccupation.value}
										list={selectListProjectedUseNewOccupation}
										hasError={errors!.includes(projectedUseOccupation.name)}
										onChange={(value) =>
											updateInput(projectedUseOccupation.name, value)
										}
										ref={
											projectedUseOccupation.ref as RefObject<HTMLSelectElement>
										}
										required={projectedUseOccupation.required}
										isSummaryStep={isSummaryStep}
									/>
								</>
							)}

							{isCase5SectionA(typesOfWorkOccupation.value) && (
								<>
									{/* Question 9.3 */}
									<SelectInput
										id={additionalProjectedUseOccupation.name}
										label={additionalProjectedUseOccupation.label}
										value={additionalProjectedUseOccupation.value}
										list={selectListProjectedUseNewOccupation}
										hasError={errors!.includes(
											additionalProjectedUseOccupation.name
										)}
										onChange={(value) =>
											updateInput(additionalProjectedUseOccupation.name, value)
										}
										ref={
											additionalProjectedUseOccupation.ref as RefObject<HTMLSelectElement>
										}
										required={additionalProjectedUseOccupation.required}
										isSummaryStep={isSummaryStep}
									/>
								</>
							)}

							{isCase6SectionA(typesOfWorkOccupation.value) && (
								<>
									{/* Question 9.4 */}
									<SelectInput
										id={conditionalProjectedUseOccupation.name}
										label={conditionalProjectedUseOccupation.label}
										value={conditionalProjectedUseOccupation.value}
										list={selectListProjectedUseNewOccupation}
										hasError={errors!.includes(
											conditionalProjectedUseOccupation.name
										)}
										onChange={(value) =>
											updateInput(conditionalProjectedUseOccupation.name, value)
										}
										ref={
											conditionalProjectedUseOccupation.ref as RefObject<HTMLSelectElement>
										}
										required={conditionalProjectedUseOccupation.required}
										isSummaryStep={isSummaryStep}
									/>
								</>
							)}
						</div>
					)}

					<h6 className={pageUtils.classes.h6}>
						{pageAssets?.request_form_occupation_description}
					</h6>

					<TextInput
						id={occupantNameSectionA.name}
						label={occupantNameSectionA.label}
						value={occupantNameSectionA.value}
						onChange={(value) => updateInput(occupantNameSectionA.name, value)}
						hasError={errors!.includes(occupantNameSectionA.name)}
						required={occupantNameSectionA.required}
						ref={occupantNameSectionA.ref as RefObject<HTMLInputElement>}
						maxCharacters={50}
						isSummaryStep={isSummaryStep}
					/>

					<MeasurementInput
						measurementInput={occupiedAreaSectionA}
						unitInput={occupiedAreaUnitSectionA}
						listMeasurementUnit={radioListMeasurement2Unit}
						maxCharacters={12}
						isSummaryStep={isSummaryStep}
						errors={errors}
						onFixError={onFixError}
						updateInput={updateInput}
						hasError={errors?.includes(occupiedAreaSectionA.name)}
						reducedMargin
					/>

					<TextAreaInput
						id={occupationActivityDescription.name}
						label={occupationActivityDescription.label}
						value={occupationActivityDescription.value}
						onChange={(value) =>
							updateInput(occupationActivityDescription.name, value)
						}
						hasError={errors!.includes(occupationActivityDescription.name)}
						required={occupationActivityDescription.required}
						ref={
							occupationActivityDescription.ref as RefObject<HTMLTextAreaElement>
						}
						maxCharacters={500}
						hasDescriptionLabel={occupationActivityDescription.description}
						displayDescriptionTop
						descriptionAlignment="left"
						rows={4}
						isSummaryStep={isSummaryStep}
					/>
				</>
			)}

			{/******************* Section B *******************/}
			{isOccupationSectionB(typesOfWorkOccupation.value) && (
				<>
					<h5 className={pageUtils.classes.h5}>
						{pageAssets?.request_form_commerialPermit_occupation_temporaryUse?.replace(
							/\*\*/g,
							''
						)}
					</h5>

					<RadioInput
						name={isLocalOrTerrain.name}
						label={isLocalOrTerrain.label}
						value={isLocalOrTerrain.value}
						list={radioIsLocalOrTerrainOptions}
						direction={Direction.vertical}
						hasError={errors!.includes(isLocalOrTerrain.name)}
						onChange={(value) => updateInput(isLocalOrTerrain.name, value)}
						ref={isLocalOrTerrain.ref as RefObject<HTMLInputElement>}
						required={isLocalOrTerrain.required}
						hasBackgroundWrapper={true}
						isSummaryStep={isSummaryStep}
					/>

					{isLocalOrTerrain.value && (
						<>
							<RadioInput
								name={occupationActivityType.name}
								label={occupationActivityType.label}
								value={occupationActivityType.value}
								list={
									isLocalOrTerrain.value ==
									REQUEST_CONFIGS_KEYS.isLocalOrTerrain.local
										? radioListOccupationActivityTypeCase1
										: radioListOccupationActivityTypeCase2
								}
								direction={Direction.vertical}
								hasError={errors!.includes(occupationActivityType.name)}
								onChange={(value) =>
									updateInput(occupationActivityType.name, value)
								}
								ref={occupationActivityType.ref as RefObject<HTMLInputElement>}
								required={occupationActivityType.required}
								hasBackgroundWrapper={true}
								isSummaryStep={isSummaryStep}
							/>

							{occupationActivityType.value ==
								REQUEST_CONFIGS_KEYS.occupationActivityType.autres && (
								<TextInput
									id={occupationActivityTypeDetails.name}
									label={occupationActivityTypeDetails.label}
									value={occupationActivityTypeDetails.value}
									onChange={(value) =>
										updateInput(occupationActivityTypeDetails.name, value)
									}
									hasError={errors!.includes(
										occupationActivityTypeDetails.name
									)}
									required={occupationActivityTypeDetails.required}
									ref={
										occupationActivityTypeDetails.ref as RefObject<HTMLInputElement>
									}
									maxCharacters={50}
									isSummaryStep={isSummaryStep}
								/>
							)}
						</>
					)}

					<h6 className={pageUtils.classes.h6}>
						{pageAssets?.request_form_occupation_description}
					</h6>

					<TextInput
						id={occupantNameSectionB.name}
						label={occupantNameSectionB.label}
						value={occupantNameSectionB.value}
						onChange={(value) => updateInput(occupantNameSectionB.name, value)}
						hasError={errors!.includes(occupantNameSectionB.name)}
						required={occupantNameSectionB.required}
						ref={occupantNameSectionB.ref as RefObject<HTMLInputElement>}
						maxCharacters={50}
						isSummaryStep={isSummaryStep}
					/>

					<MeasurementInput
						measurementInput={occupiedAreaSectionB}
						unitInput={occupiedAreaUnitSectionB}
						listMeasurementUnit={radioListMeasurement2Unit}
						maxCharacters={12}
						isSummaryStep={isSummaryStep}
						errors={errors}
						onFixError={onFixError}
						updateInput={updateInput}
						hasError={errors?.includes(occupiedAreaSectionB.name)}
						reducedMargin
					/>
				</>
			)}

			{/******************* Section C *******************/}
			{isOccupationSectionC(typesOfWorkOccupation.value) && (
				<>
					<h5 className={pageUtils.classes.h5}>
						{pageAssets?.request_form_conditionnalUse}
					</h5>

					{/* conditionalUseAuthorizationRequest Radio */}
					<RadioInput
						name={conditionalUseAuthorizationRequest.name}
						label={conditionalUseAuthorizationRequest.label}
						value={conditionalUseAuthorizationRequest.value}
						list={radioListYesNo}
						direction={Direction.vertical}
						hasError={errors!.includes(conditionalUseAuthorizationRequest.name)}
						onChange={(value) =>
							updateInput(conditionalUseAuthorizationRequest.name, value)
						}
						ref={
							conditionalUseAuthorizationRequest.ref as RefObject<HTMLInputElement>
						}
						required={conditionalUseAuthorizationRequest.required}
						hasBackgroundWrapper={true}
						isSummaryStep={isSummaryStep}
					/>

					{conditionalUseAuthorizationRequest.value?.toString() == 'true' && (
						<>
							{/* Numéro de UC (usage conditionnel) */}
							<MaskedTextInput
								id={conditionalUseNumber.name}
								label={conditionalUseNumber.label}
								value={conditionalUseNumber.value}
								onChange={(value) => {
									const formattedValue = value.toLocaleUpperCase()
									const finalValue =
										formattedValue === '' ? '' : `UC-${formattedValue}`

									updateInput(conditionalUseNumber.name, finalValue)
								}}
								hasError={errors.includes(conditionalUseNumber.name)}
								required={conditionalUseNumber.required}
								ref={conditionalUseNumber.ref as RefObject<HTMLInputElement>}
								max={9}
								min={9}
								mask="0000-0000"
								placeholder="XXXX-XXXX"
								prefix="UC-"
								errors={errors}
								setError={onFixError}
								schema={/^UC-\d{4}-\d{4}$/}
								isSummaryStep={isSummaryStep}
							/>

							{/* Numéro de résolution du comité exécutif (CE) */}
							<MaskedTextInput
								id={executiveCommitteeResolutionNumber.name}
								label={executiveCommitteeResolutionNumber.label}
								value={executiveCommitteeResolutionNumber.value}
								onChange={(value) => {
									const formattedValue = value.toLocaleUpperCase()
									const finalValue =
										formattedValue === '' ? '' : `CE-${formattedValue}`

									updateInput(
										executiveCommitteeResolutionNumber.name,
										finalValue
									)
								}}
								hasError={errors.includes(
									executiveCommitteeResolutionNumber.name
								)}
								required={executiveCommitteeResolutionNumber.required}
								ref={
									executiveCommitteeResolutionNumber.ref as RefObject<HTMLInputElement>
								}
								max={9}
								min={9}
								mask="0000-0000"
								placeholder="XXXX-XXXX"
								prefix="CE-"
								errors={errors}
								setError={onFixError}
								schema={/^UC-\d{4}-\d{4}$/}
								isSummaryStep={isSummaryStep}
							/>
						</>
					)}
					{conditionalUseAuthorizationRequest.value?.toString() == 'false' && (
						<>
							<Notification
								text={
									pageAssets?.request_form_conditionalUseAuthorizationRequest_notification_label
								}
								type="warning"
								hasHtml
							/>
						</>
					)}
				</>
			)}
			{/******************* Section D *******************/}
			{isOccupationSectionD(typesOfWorkOccupation.value) && (
				<>
					<h5 className={pageUtils.classes.h5}>
						{pageAssets?.request_form_dateOccupation}
					</h5>

					<div className={pageUtils.classes.fieldsContainer}>
						<DateFilterInput
							id={startDateOccupation.name}
							label={startDateOccupation.label}
							value={startDateOccupation.value}
							onChange={(value) => updateInput(startDateOccupation.name, value)}
							hasError={errors!.includes(startDateOccupation.name)}
							required={startDateOccupation.required}
							dateFormat="dd/MM/yyyy"
							minDate={new Date()}
							isSummaryStep={isSummaryStep}
						/>

						<DateFilterInput
							id={endDateOccupation.name}
							label={endDateOccupation.label}
							value={endDateOccupation.value}
							onChange={(value) => updateInput(endDateOccupation.name, value)}
							hasError={errors!.includes(endDateOccupation.name)}
							required={endDateOccupation.required}
							dateFormat="dd/MM/yyyy"
							minDate={new Date(startDateOccupation.value + 'T12:00:00')}
							disabled={startDateOccupation.value == ''}
							isSummaryStep={isSummaryStep}
						/>
					</div>
				</>
			)}

			{/******************* Section E *******************/}
			{isOccupationSectionE(typesOfWorkOccupation.value) && (
				<>
					<h5 className={pageUtils.classes.h5}>
						{pageAssets?.request_form_additional_info}
					</h5>

					{/* Des modifications au local (rénovation ou aménagement) sont-elles requises? */}
					<>
						<RadioInput
							name={isLocalModificationsRequired.name}
							label={isLocalModificationsRequired.label}
							value={isLocalModificationsRequired.value}
							list={radioListYesNo}
							direction={Direction.vertical}
							hasError={errors!.includes(isLocalModificationsRequired.name)}
							onChange={(value) =>
								updateInput(isLocalModificationsRequired.name, value)
							}
							ref={
								isLocalModificationsRequired.ref as RefObject<HTMLInputElement>
							}
							required={isLocalModificationsRequired.required}
							hasBackgroundWrapper={true}
							isSummaryStep={isSummaryStep}
							reducedMargin={true}
						/>

						{!isSummaryStep &&
							isLocalModificationsRequired.value?.toString() == 'true' && (
								<Notification
									text={
										pageAssets?.request_form_isLocalModificationsRequired_notification_label
									}
									type="info"
									hasHtml
								/>
							)}
					</>

					{/* Prévoyez-vous faire l'installation d'enseigne(s)? */}
					<>
						<RadioInput
							name={isEnseigneInstallationPrevue.name}
							label={isEnseigneInstallationPrevue.label}
							value={isEnseigneInstallationPrevue.value}
							list={radioListYesNo}
							direction={Direction.vertical}
							hasError={errors!.includes(isEnseigneInstallationPrevue.name)}
							onChange={(value) =>
								updateInput(isEnseigneInstallationPrevue.name, value)
							}
							ref={
								isEnseigneInstallationPrevue.ref as RefObject<HTMLInputElement>
							}
							required={isEnseigneInstallationPrevue.required}
							hasBackgroundWrapper={true}
							isSummaryStep={isSummaryStep}
							reducedMargin={true}
						/>

						{!isSummaryStep &&
							isEnseigneInstallationPrevue.value?.toString() == 'true' && (
								<Notification
									text={
										pageAssets?.request_form_isEnseigneInstallationPrevue_notification_label
									}
									type="info"
									hasHtml
								/>
							)}
					</>

					{!isOccupationSectionB(typesOfWorkOccupation.value) && (
						<>
							{/* Prévoyez-vous l'obtention d'un permis d'alcool (R.A.C.J)? */}
							<>
								<RadioInput
									name={isAlcoholPermitRequired.name}
									label={isAlcoholPermitRequired.label}
									value={isAlcoholPermitRequired.value}
									list={radioListYesNo}
									direction={Direction.vertical}
									hasError={errors!.includes(isAlcoholPermitRequired.name)}
									onChange={(value) =>
										updateInput(isAlcoholPermitRequired.name, value)
									}
									ref={
										isAlcoholPermitRequired.ref as RefObject<HTMLInputElement>
									}
									required={isAlcoholPermitRequired.required}
									hasBackgroundWrapper={true}
									isSummaryStep={isSummaryStep}
									reducedMargin={true}
								/>

								{isAlcoholPermitRequired.value?.toString() == 'true' && (
									<>
										{!isSummaryStep && (
											<Notification
												text={
													pageAssets?.request_form_isAlcoholPermitRequired_notification_label
												}
												type="info"
												hasHtml
											/>
										)}

										{/* Pour quel(s) type(s) d'activités? */}
										<RadioInput
											name={alcoholPermitActivityType.name}
											label={alcoholPermitActivityType.label}
											value={alcoholPermitActivityType.value}
											list={radioListAlcoholPermitActivityType}
											direction={Direction.vertical}
											hasError={errors!.includes(
												alcoholPermitActivityType.name
											)}
											onChange={(value) =>
												updateInput(alcoholPermitActivityType.name, value)
											}
											ref={
												alcoholPermitActivityType.ref as RefObject<HTMLInputElement>
											}
											required={alcoholPermitActivityType.required}
											hasBackgroundWrapper={true}
											isSummaryStep={isSummaryStep}
										/>

										{/* Veuillez préciser */}
										{alcoholPermitActivityType.value ==
											REQUEST_CONFIGS_KEYS.alcoholPermitActivityType.autre && (
											<TextInput
												id={alcoholPermitActivityTypeDetails.name}
												label={alcoholPermitActivityTypeDetails.label}
												value={alcoholPermitActivityTypeDetails.value}
												onChange={(value) =>
													updateInput(
														alcoholPermitActivityTypeDetails.name,
														value
													)
												}
												hasError={errors!.includes(
													alcoholPermitActivityTypeDetails.name
												)}
												required={alcoholPermitActivityTypeDetails.required}
												ref={
													alcoholPermitActivityTypeDetails.ref as RefObject<HTMLInputElement>
												}
												maxCharacters={100}
												isSummaryStep={isSummaryStep}
											/>
										)}
									</>
								)}
							</>

							{/* Prévoyez-vous l'obtention d'une attestation municipale pour la vente de véhicules routiers (O.P.C.) */}
							<>
								<RadioInput
									name={isMunicipalCertificateRequired.name}
									label={isMunicipalCertificateRequired.label}
									value={isMunicipalCertificateRequired.value}
									list={radioListYesNo}
									direction={Direction.vertical}
									hasError={errors!.includes(
										isMunicipalCertificateRequired.name
									)}
									onChange={(value) =>
										updateInput(isMunicipalCertificateRequired.name, value)
									}
									ref={
										isMunicipalCertificateRequired.ref as RefObject<HTMLInputElement>
									}
									required={isMunicipalCertificateRequired.required}
									hasBackgroundWrapper={true}
									isSummaryStep={isSummaryStep}
									reducedMargin={true}
								/>

								{!isSummaryStep &&
									isMunicipalCertificateRequired.value?.toString() ==
										'true' && (
										<Notification
											text={
												pageAssets?.request_form_isMunicipalCertificateRequired_notification_label
											}
											type="info"
											hasHtml
										/>
									)}
							</>

							{/* Prévoyez-vous faire l'ajout ou la modification d'une terrasse? */}
							<>
								<RadioInput
									name={isTerraceModificationRequired.name}
									label={isTerraceModificationRequired.label}
									value={isTerraceModificationRequired.value}
									list={radioListYesNo}
									direction={Direction.vertical}
									hasError={errors!.includes(
										isTerraceModificationRequired.name
									)}
									onChange={(value) =>
										updateInput(isTerraceModificationRequired.name, value)
									}
									ref={
										isTerraceModificationRequired.ref as RefObject<HTMLInputElement>
									}
									required={isTerraceModificationRequired.required}
									hasBackgroundWrapper={true}
									isSummaryStep={isSummaryStep}
									reducedMargin={true}
								/>

								{!isSummaryStep &&
									isTerraceModificationRequired.value?.toString() == 'true' && (
										<Notification
											text={
												pageAssets?.request_form_isTerraceModificationRequired_notification_label
											}
											type="info"
											hasHtml
										/>
									)}
							</>
						</>
					)}

					{/* Êtes-vous propriétaire ou locataire du local voulant être occupé? */}
					<RadioInput
						name={isLocataireOccupation.name}
						label={isLocataireOccupation.label}
						value={isLocataireOccupation.value}
						list={radioListOwnerOrRenter}
						direction={Direction.vertical}
						hasError={errors!.includes(isLocataireOccupation.name)}
						onChange={(value) => updateInput(isLocataireOccupation.name, value)}
						ref={isLocataireOccupation.ref as RefObject<HTMLInputElement>}
						required={isLocataireOccupation.required}
						hasBackgroundWrapper={true}
						isSummaryStep={isSummaryStep}
					/>
				</>
			)}
		</>
	)
}

export default Step4_2RequestOccupation
